import { HostListener, Component } from '@angular/core';

import {
    NavController,
    ViewController,
    LoadingController} from 'ionic-angular';

import { RodeoService } from '../../services/rodeo.service';

@Component({
    selector: 'page-draw-simulation',
    templateUrl: 'draw-simulation.html'
})
export class DrawSimulation {
    maxTests: number;
    avgEntries: number;
    percentMultiRodeo: number = .6;
    buddyChance: number;
    rodeoCount: number;
    turnoutChance: number;
    anyPrefChance: number;

    randomEntryPlacement: string = "0";
    randomPrefPlacement: string = "0";

    smartEntryPlacement: string = "0";
    smartPrefPlacement: string = "0";

    simulating: boolean;

    constructor(private nav : NavController, private rodeoService : RodeoService, private viewController : ViewController, private loadingController : LoadingController) {
    }

    back() {
        this.nav.pop();
    }

    _bdClick() {
        return this.nav.pop();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast()) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }

    simulate() {
        if (this.simulating)
            return;

        this.simulating = true;

        let loader = this.loadingController.create({
            content: 'Simulating entry placement....'
        });

        loader.present();
        
        this.rodeoService.simulateRodeos(this.maxTests, this.avgEntries, .6, this.buddyChance, this.rodeoCount, this.turnoutChance, this.anyPrefChance)
        .then(data => {
            this.randomEntryPlacement = '' + Math.round((data as any).randomEntryPlacement * 10) / 10;
            this.randomPrefPlacement = '' + Math.round((data as any).randomPrefPlacement * 10) / 10;

            this.smartEntryPlacement = '' + Math.round((data as any).smartEntryPlacement * 10) / 10;
            this.smartPrefPlacement = '' + Math.round((data as any).smartPrefPlacement * 10) / 10;

            this.simulating = false;
            loader.dismiss();
        }, error => {
            this.simulating = false;
            loader.dismiss();
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/rodeo/draw-simulation.ts